import React from 'react';
import {FileList} from "./FileList/FileList";
import PopupSelectOrderFile from "./PopupSelectOrderFile";
import ButtonDropdownCommon from "../../../../../common/components/ButtonDropdownCommon";
import ButtonCommon from "../../../../../common/components/ButtonCommon";
import ItemPasteFile from './ItemPasteFile';
import {useInspectionOtherFilesContext} from "../../InspectionOtherFilesContext";
import {uploadFileTypes} from "../constants/uploadFileTypes";
import AnimatedUploadingFilePopUp from "../../../../../common/components/AnimatedUploadingFilePopUp";
import styles from "../styles.module.scss";

export const SectionFiles = ({orderID}) => {
  const {
    fileList,
    orderFileList,
    uploading,
    fileActions
  } = useInspectionOtherFilesContext();

  const getItemUploadFile = (item, index) => {

    return (
      <ItemPasteFile
        key={index}
        label={item.label}
        fileTypeID={item.id}
        fileActions={fileActions}
        multiple={item.id === 11 || item.id === 17}
      />
    )
  };

  const getItemPopupOrderFiles = (item) => {

    return (
      <PopupSelectOrderFile
        label={item.label}
        fileTypeID={item.id}
        orderFileList={orderFileList}
        fileActions={fileActions}
      />
    )
  };

  return (
    <div className={styles.sectionFilesContainer}>
      <AnimatedUploadingFilePopUp show={uploading}/>
      <div className={styles.buttonsContainer}>
        <ButtonDropdownCommon
          customMenuStyles={styles.menu}
          triggerComponent={
            <ButtonCommon
              label={'העלה קובץ'}
              customContainerStyles={styles.buttonUploadFile}
            />
          }
          content={uploadFileTypes.map(getItemUploadFile)}
        />
        <ButtonDropdownCommon
          customMenuStyles={styles.menu}
          triggerComponent={
            <ButtonCommon
              label={'בחירת קובץ מההזמנה'}
              customContainerStyles={styles.buttonUploadFile}
            />
          }
          content={uploadFileTypes.map(getItemPopupOrderFiles)}
          disabled={Boolean(!orderID)}
        />
      </div>
      <FileList
        fileList={fileList}
        fileActions={fileActions}
      />
    </div>
  );
}
